import { FC, PropsWithChildren, useEffect } from "react";
import { useApp } from "AppContext";
import { useNavigate } from "react-router";
import { LoadingError, Select, TopBar } from "@kaladel/react/Components";
import styles from "./HomeLayout.module.scss";

export const HomeLayout: FC<PropsWithChildren> = (props) => {
    const { session, activeCurrency, setActiveCurrency, status } = useApp();
    const navigate = useNavigate();

    useEffect(() => {
        if (!session) {
            navigate("/");
        }
    }, [session]);

    useEffect(() => {
        if (!activeCurrency) {
            if (session?.defaultCurrencyId) {
                setActiveCurrency(session.defaultCurrencyId);
            }
            else if (status?.length) {
                setActiveCurrency(status[0].currency.code);
            }
        }
    }, [status]);

    return (
        <>
            <TopBar
                appName="MoneyChecker"
                homeLink="/home"
                className={styles.topBar}
                rightContent={(
                    <LoadingError
                        value={status}
                        loaded={currenciesInUse => (
                            <Select
                                id="activeCurrency"
                                items={currenciesInUse}
                                values={c => c.currency.code}
                                descriptions={c => `${c.currency.code} - ${c.currency.friendlyName}`}
                                value={activeCurrency ?? ""}
                                onChange={e => setActiveCurrency(e.target.value)}
                                validations={{ required: true }}
                            />
                        )}
                    />
                )}
            />
            <div className={styles.content}>
                {props.children}
            </div>
        </>
    );
};